import { PriceUtils } from "../../utils/PriceUtils";
import { TBookingPriceData } from "./useBookingCard";

export const PriceDataHelper = class {
  ls: TBookingPriceData[];
  constructor(
    splitedBookings: BookingState[],
    priceOfSingleBookings?: PriceOfSingleBookingDTO[],
  ) {
    this.ls = (priceOfSingleBookings ?? [])
      .map((x, i) => ({
        currentBPrice: x,
        currentBState: splitedBookings[i],
      }))
      .filter((x) => x.currentBState && x.currentBPrice);
  }

  isPass() {
    return this.ls?.some((x) => x.currentBPrice.pakage);
  }

  totalOfBeforeServiceFeeTotalOfOrder(): number {
    return this.ls
      .map((x) => x.currentBPrice.beforeServiceFeeTotalOfOrder ?? 0)
      .reduce((a, b) => a + b, 0);
  }

  totalOfCartTotal(): number {
    return this.ls
      .map((x) => x.currentBPrice.cartTotal ?? 0)
      .reduce((a, b) => a + b, 0);
  }

  totalOf(t: TPriceItem): number {
    return this.ls
      .map((x) => {
        return PriceUtils.findPriceItem(x.currentBPrice, t)?.actualAmount ?? 0;
      })
      .reduce((a, b) => a + b, 0);
  }
};
